import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';

import App from './App';
import { registerPwa } from './pwa';
import { initSentry, Sentry } from './lib/sentry';
import './styles/index.css';

initSentry();
registerPwa();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, retry: 1, staleTime: 30_000 },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<CrashFallback />} showDialog={false}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
          <Toaster position="top-right" toastOptions={{ duration: 3500 }} />
        </BrowserRouter>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);

function CrashFallback() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        background: '#0E1747',
        color: '#FFFFFF',
        fontFamily: 'Inter, system-ui, sans-serif',
        padding: 24,
      }}
    >
      <div style={{ maxWidth: 420, textAlign: 'center' }}>
        <div
          style={{
            fontSize: 11,
            letterSpacing: '0.14em',
            textTransform: 'uppercase',
            opacity: 0.6,
            marginBottom: 12,
          }}
        >
          Ошибка интерфейса
        </div>
        <h1 style={{ fontSize: 24, fontWeight: 500, margin: 0 }}>Что-то пошло не так</h1>
        <p style={{ marginTop: 16, fontSize: 15, lineHeight: 1.6, opacity: 0.85 }}>
          Мы уже получили отчёт об ошибке. Попробуйте перезагрузить страницу.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            marginTop: 24,
            padding: '12px 22px',
            background: '#E85624',
            color: '#FFFFFF',
            border: 0,
            cursor: 'pointer',
            fontSize: 14,
            fontWeight: 500,
          }}
        >
          Перезагрузить
        </button>
      </div>
    </div>
  );
}
